import { createContext } from "react";
export default createContext({ loggedin: false, username: null, user_type: "support" });